import Alerts from "../../../pages/signed-out/alerts/alerts.component"

const AlertsRoute = () => {
  return (
    <Alerts/>
  )
}

export default AlertsRoute